<template>
  <th
    :style="[styleWidth]"
    :class="[
      col.cssCellClass,
      {empty: !col.caption, 'sticky lock': hasLockColumn && col.lock},
      String(col.align || ''),
      'ms-col-th',
    ]"
    :field="col.dataField"
  >
    <div :class="filterable ? 'flex-column' : ''" :style="filterable && fitContent ? 'height: fit-content;' : ''">
      <div :class="['ms-th-content flex-row', filterable ? 'flex' : '']">
        <div
          class="ms-th-title flex flex-row"
          :title="col.tooltip || col.title || col.definition || col.caption"
          :class="{
            'has-lock': col.lockable !== false,
            'has-sort': col.sortable !== false,
            'pdl-10': col.lockable === false,
            'pdr-10': !col.sortable,
            'height-group': col.group,
          }"
          @click="sort"
        >
          <div
            v-if="col.lockable !== false && !col.group"
            class="icon24"
            :class="{locked: hasLockColumn && col.lock, lock: !col.lock}"
            @click="lockClick"
          />
          <!-- v-tooltip="col.tooltip " -->
          <span :class="['flex', `text-${col.align || 'left'}`, col.cssClass]">{{ col.caption }}</span>
          <div
            v-if="col.sortable !== false"
            class="icon24 mi-arrow-dropdown ml5 mr0"
            :class="[
              {sort: sortStatus == $ms.constant.SortStatus.none},
              {'sort-desc': sortStatus == $ms.constant.SortStatus.desc},
              {'sort-asc': sortStatus == $ms.constant.SortStatus.asc},
            ]"
            @click.stop="sort"
          />
        </div>

        <!-- <div
        class="ms-lock"
        :class="{ locked: col.lock }"
        v-if="col.lockable !== false && false"
        @click="lockClick"
      ></div> -->
        <div v-if="resizeCol" class="ms-resize" @mouseup="resizeOff" @mousedown="resizeOn" />
      </div>
      <template v-if="filterable">
        <component
          :is="filterComponentName"
          v-if="col.filterable && filterComponentName && !disabled"
          ref="cpnFilter"
          :col="col"
          :props-data="propsData"
          @filter-header="filterHeaderHandle"
          @load-filter-header="onLoadFilterHeader"
        />
        <div v-else class="filter-container-empty" />
      </template>
    </div>
  </th>
</template>
<script>
import {defineComponent, onMounted, ref} from 'vue';
import {useColumnResize} from '@/setup/grid/resizeColumn.js';

// FilterComponent
import setup from '@/components/gridViewer/columnOption/render-helper.js';
import msThText from './columnOption/MsThOptionText.vue';
import msThBoolean from './columnOption/MsThOptionBoolean.vue';
import msThNumber from './columnOption/MsThOptionNumber.vue';
import msThDate from './columnOption/MsThOptionDate.vue';
import msThEnum from './columnOption/MsThOptionEnum.vue';
import msThCombobox from './columnOption/MsThOptionCombobox.vue';
import msThComboboxMultiple from './columnOption/MsThOptionComboboxMultiple.vue';
export default defineComponent({
  name: 'MsTh',
  components: {
    msThText,
    msThBoolean,
    msThNumber,
    msThDate,
    msThEnum,
    msThCombobox,
    msThComboboxMultiple,
  },
  props: {
    col: {},
    data: {},
    resizeCol: {
      default: true,
      type: Boolean,
    },
    filterable: {
      type: Boolean,
      default: false,
    },
    fitContent: {
      type: Boolean,
      default: true,
    },
    moduleAutocomplete: {
      type: String,
      default: null,
    },
    propsData: {
      default: {},
      type: Object,
    },
    disabled: {
      default: false,
      type: Boolean,
    },

    /**
     * biến global grid có lockable ko ?
     */
    hasLockColumn: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['resizeOn', 'resizeOff', 'changeColumnResize', 'sort', 'changeLock', 'filter', 'load-filter-header'],
  setup(props, {emit}) {
    const filterComponentName = ref(null);
    const cpnFilter = ref(null);

    // Lấy hàm trong fn chung
    const {getFilterType} = setup(props, {emit});

    // Hooks
    /**
     * Build component filter theo data type control
     * HTHIEP 14.03.2022
     */
    onMounted(() => {
      filterComponentName.value = getFilterType(props.col);
      widthx.value = props.col._width;
    });

    /**
     * Trigger sự kiện filter từ con
     * HTHIEP 14.03.2022
     */
    const filterHeaderHandle = value => {
      emit('filter', {col: props.col, value});
    };

    /**
     * Xóa giá trị trên cột filter
     * HTHIEP 14.03.2022
     */
    const removeFilter = (trigger = true) => {
      cpnFilter.value.removeFilter(trigger);
    };

    /**
     * Xử lý event load-filter-header từ component con
     * ntchuyen 06.11.2025
     */
    const onLoadFilterHeader = (payload, row, dataField) => {
      emit('load-filter-header', payload, row, dataField);
    };

    const {sortStatus, styleWidth, sort, lockClick, updateColWidth, resizeOn, widthx, resizeOff} = useColumnResize({
      props,
      emit,
    });
    return {
      styleWidth,
      sortStatus,
      filterComponentName,
      cpnFilter,
      sort,
      lockClick,
      updateColWidth,
      resizeOn,
      filterHeaderHandle,
      removeFilter,
      resizeOff,
      onLoadFilterHeader,
    };
  },
  methods: {},
});
</script>

<style lang="scss">
li.filter-operator-item {
  align-items: center;
  &.active {
    background-color: $ms-grid-hover-and-selected;
  }
}

.ms-th {
  .filter-container-empty {
    height: $ms-empty-filter-grid-height; // thay đổi theo pbi 51543
    border-top: 1px solid $ms-th-grid-border-color;
    background: #fff;
  }
  .filter-container {
    height: $ms-filter-grid-height;
    border-top: 1px solid $ms-th-grid-border-color;
    // border-right: 1px dashed $ms-th-grid-border-color;
    .menu-wrapper {
      &.active button {
        background-color: $ms-grid-hover-and-selected;
      }
    }

    &.filter-container-boolean {
      .filter-value {
        background: #fff;
      }
    }
    .filter-op {
      position: relative;
      z-index: 2;

      .btn-filter-operator {
        height: $ms-filter-item-grid-height;
        width: $ms-filter-operator-grid-width;
        border: none;
        border-right: 1px dotted $ms-th-grid-border-color;
        background: #fff;
        padding: 0;
        cursor: pointer;
        &:focus,
        &:active,
        &:focus-visible {
          outline: none;
        }
      }
    }
    .filter-value {
      .ms-input-filter-value {
        .ms-input-item,
        .ms-number-item,
        .ms-input--datepicker,
        .combo-box-input input {
          height: $ms-filter-item-grid-height;
          border-radius: 0;
          &:focus {
            outline: none;
          }
        }
        .ms-container--datepicker {
          // &:hover {
          //   .ms-calendar:not(.disabled) {
          //     &::before {
          //       display: block;
          //     }
          //   }
          // }

          .ms-calendar {
            width: 24px;
            display: block;
            &::before {
              content: '';
              position: absolute;
              background: transparent $ms-image-sprites no-repeat 0px -96px;
              height: 24px;
              width: 24px;
              left: 0;
              top: 0;
            }
          }
        }
        .combo-box-input div div {
          background: #fff;
        }
        .icon-combo--dropdown {
          height: $ms-filter-item-grid-height;
          background: #fff;
          border-left: 1px dotted $ms-th-grid-border-color;
          border-radius: 0;
          width: 24px;
          &:before {
            content: '';
            position: absolute;
            width: 24px;
            height: 24px;
            display: inline-block;
            background: transparent $ms-image-sprites no-repeat -336px -47px;
            top: 0px;
            left: 0px;
            transform: rotate(0deg);
            // transition: all 0.3s ease;
          }
        }
      }
      position: relative;
      z-index: 1;
    }
  }

  .sort::before {
    background-position: -48px -120px;
    opacity: 0.5;
  }
  .sort-desc::before {
    background-position: 0 -120px;
    opacity: 0.5;
  }
  .sort-asc::before {
    background-position: -24px -120px;
    opacity: 0.5;
  }
}

.ms-col-th-last {
  .filter-container {
    border-right: none;
  }
}
</style>
